module.exports = __webpack_public_path__ + "static/media/question-mark.99ea11d9.png";